import "./App.css";
import { RecoilRoot } from "recoil";

function App() {
  return (
    <RecoilRoot>
      <div></div>
    </RecoilRoot>
  );
}

export default App;
